module.exports = __webpack_public_path__ + "img/diner.bbaad621.png";